import React, { Component } from "react";

import ReactUUID from "react-uuid";

export default class UBXTree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            id: "",
            collapsed: true,
        };
    }

    async componentDidMount() {
        const { id = ReactUUID(), collapsed = false } = this.props;

        const initialState = { id, collapsed, ready: true };

        await this.setState(initialState);
    }

    itemToggleClick(e) {
        const { target } = e;
        const { collapsed } = this.state;
        const { onToggle = false } = this.props;

        if (target.classList.contains("tree-title")) {
            this.setState({ collapsed: !collapsed });

            if (onToggle) {
                onToggle(e);
            }
        }

        return false;
    }

    renderTitle() {
        const { title = "", link = false, collapsible = false, status = "" } = this.props;
        const { collapsed } = this.state;

        let renderedTitle = "";
        if (title) {
            const customClass = ["tree-title"];
            if (collapsible) {
                customClass.push("toggle");
                if (collapsed) {
                    customClass.push("collapsed");
                }
            }

            if (status) {
                customClass.push(status);
            }

            const titleElement = link ? <a href={link}>{title}</a> : <span>{title}</span>;

            renderedTitle = (
                <p className={customClass.join(" ")} title={title} onClick={(e) => this.itemToggleClick(e)}>
                    {titleElement}
                </p>
            );
        }

        return renderedTitle;
    }

    renderItems() {
        const { children } = this.props;

        let renderedItems = [];
        if (children && children.length > 0) {
            children.forEach((child, childIdx) => {
                renderedItems.push(<li key={childIdx}>{child}</li>);
            });
        }

        return renderedItems.length > 0 ? <ul>{renderedItems}</ul> : "";
    }

    render() {
        const { id, ready } = this.state;
        const { className: customClassName = "", type = false } = this.props;

        const customAttrs = { id };

        const className = ["ubx-commons", "tree"];
        if (customClassName) {
            className.push(customClassName);
        }

        if (type) {
            className.push(type);
        }

        return (
            ready && (
                <div className={className.join(" ")} {...customAttrs}>
                    {this.renderTitle()}
                    {this.renderItems()}
                </div>
            )
        );
    }
}
